/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { object } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import { dateMMMMDDYYYY } from '../../../utils/dateString';
import DesktopOrderTrackingPlants from '../DesktopItemDetail/DesktopOrderTrackingPlants';

const styles = (theme) => ({
    OrderDetailItem: {
        padding: '0 15px',
        paddingBottom: '80px',
        marginTop: '1rem !important',
        borderBottom: '1px dashed #000',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '20px',
            paddingBottom: '20px',
            borderTop: '1px dashed #000',
            borderBottom: '1px dashed #000',
        },
        '& .thead, .sm-screen': {
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: '1px dashed #000',
            textTransform: 'uppercase !important',
        },
        '& .tbody': {
            marginTop: '1rem !important',

            '& img': {
                width: '120px',
            },

            '& .section': {
                '& > span': {
                    display: 'block',
                    fontSize: '1rem',

                    '& .bold': {
                        fontWeight: 600,
                    },
                },
            },

            '& .desktopStatusTracking': {
                '& .MuiStepper-root, .MuiStep-horizontal': {
                    padding: 0,
                },
            },

            '& > div:nth-child(odd)': {
                [theme.breakpoints.down('sm')]: {
                    paddingRight: '15px',
                },
            },
        },
        '& .sm-hide': {
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
        },
        '& .sm-screen': {
            fontSize: '16px',
            borderBottom: '0px',
            marginBottom: '3px',
            textTransform: 'uppercase !important',
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
        '& .font-nr': {
            fontWeight: '500',
        },
        '& .sm-mt-3': {
            [theme.breakpoints.down('sm')]: {
                marginTop: '3rem',
            },
        },
        '& .desktopStatusTracking': {
            [theme.breakpoints.down('sm')]: {
                '& .MuiStepper-root': {
                    maxWidth: '350px',
                },
                '& .MuiStep-root': {
                    '&.MuiStep-completed': {
                        '& span': {
                            fontWeight: '700',
                        },
                    },
                    '& .MuiStepLabel-root': {
                        '& .MuiStepLabel-labelContainer': {
                            '& *': {
                                fontSize: '16px',
                                marginTop: '5px',
                            },
                        },
                    },
                    '&:nth-child(1)': {
                        '& .MuiStepLabel-root': {
                            alignItems: 'start',
                            '& .MuiStepLabel-labelContainer': {
                                '& *': {
                                    textAlign: 'left',
                                },
                            },
                        },
                    },
                    '&:nth-child(2)': {
                        '& .MuiStepConnector-root': {
                            left: 'calc(-50% - 30px)',
                        },
                    },
                    '&:nth-child(3)': {
                        '& .MuiStepConnector-root': {
                            right: 'calc(50% - 30px)',
                        },
                        '& .MuiStepLabel-root': {
                            alignItems: 'end',
                            '& .MuiStepLabel-labelContainer': {
                                '& *': {
                                    textAlign: 'right',
                                },
                            },
                        },
                    },
                },
            },
        },

        '& .mt-2': {
            marginTop: '2rem',
        },
    },
});

const DesktopOrderListItem = ({ orderDetails, classes }) => {
    const order = orderDetails.orders[0];

    const getformattedOrderDetails = (orderData) => {
        const tempOrderDetails = {};

        orderData.orders.forEach((orderValue) => {
            const orderReplica = { ...orderValue };
            orderReplica.items[0].tax = orderReplica.billingProfile.tax;

            if (tempOrderDetails[orderReplica.orderNumber]) {
                const item = orderReplica.items[0];
                item.recipientProfiles = orderReplica.recipientProfiles[0];
                tempOrderDetails[orderReplica.orderNumber].items.push(item);
            } else {
                orderReplica.items[0].recipientProfiles = orderReplica.recipientProfiles[0];
                tempOrderDetails[orderReplica.orderNumber] = orderReplica;
            }
        });

        const formattedOrderDetails = JSON.parse(JSON.stringify(tempOrderDetails));

        // merge if we are getting same sku as multiple item.
        Object.keys(tempOrderDetails).forEach((orderId) => {
            formattedOrderDetails[orderId].items = [formattedOrderDetails[orderId].items[0]];
            tempOrderDetails[orderId].items.forEach((item, index) => {
                if (index !== 0 && tempOrderDetails[orderId].items[0].productSku === item.productSku) {
                    formattedOrderDetails[orderId].items[0].quantity = +formattedOrderDetails[orderId].items[0].quantity + +item.quantity;
                } else if (tempOrderDetails[orderId].items[0].productSku !== item.productSku) {
                    formattedOrderDetails[orderId].items.push(item);
                }
            });
        });

        return Object.values(formattedOrderDetails)[0];
    };

    const tempOrderDetails = JSON.parse(JSON.stringify(orderDetails));
    tempOrderDetails.orders = [getformattedOrderDetails(tempOrderDetails)];

    return (
        <div className={classes.OrderDetailItem}>
            <Grid container className="thead sm-hide">
                <Grid xs={2} sm={2} md={2} lg={2}>Items Ordered:</Grid>
                <Grid xs={2} sm={2} md={2} lg={2}>Delivery Address:</Grid>
                <Grid xs={2} sm={2} md={2} lg={2}>Delivery Date:</Grid>
                <Grid xs={2} sm={2} md={3} lg={3} align="center">Order Status:</Grid>
                <Grid xs={2} sm={2} md={2} lg={2}>Tracking Number:</Grid>
                <Grid xs={2} sm={2} md={1} lg={1}>Price:</Grid>
            </Grid>

            <Grid container className="tbody">
                {tempOrderDetails.orders.map((orderValue) => (
                    orderValue.items.map((data) => {
                        const shippingDetails = data?.recipientProfiles;
                        const shippingAddress = shippingDetails?.addressDetail[0];
                        const phoneNumber = shippingDetails.phones[0]?.phone[0]?.number;

                        return (
                            <Grid container className="mt-2">
                                <Grid xs={6} sm={6} md={2} lg={2}>
                                    <Grid xs={12} sm={12} className="sm-screen">Items Ordered:</Grid>
                                    <img src={data.prdImgCtg} alt="product-image" />
                                    <div className="section sm-hide">
                                        <span className="bold">QTY: {data.quantity}</span>
                                        <span>{data.productName}</span>
                                    </div>
                                </Grid>
                                <Grid xs={6} sm={6} md={2} lg={2}>
                                    <Grid xs={12} sm={12} className="sm-screen">Delivery Address:</Grid>
                                    <div className="section">
                                        <span>{shippingDetails?.firstName} {shippingDetails?.lastName}</span>
                                        <span>{shippingDetails?.emailAddress}</span>
                                        <span>{shippingAddress.addressLine1},</span>
                                        {shippingAddress.addressLine2 ? <span>{shippingAddress.addressLine2},</span> : ''}
                                        <span>{shippingAddress.cityName}, {shippingAddress.state}, {shippingAddress.zipCode}</span>
                                        {phoneNumber ? <span>{phoneNumber}</span> : ''}
                                    </div>
                                </Grid>

                                <Grid xs={6} sm={6} className="sm-screen">
                                    <div className="section">
                                        <span className="bold">QTY: {data.quantity}</span>
                                        <span className="font-nr">{data.productName}</span>
                                    </div>
                                </Grid>

                                <Grid xs={6} sm={6} className="sm-screen">
                                    <Grid xs={12} sm={12} className="sm-screen">Price:</Grid>
                                    <div className="section">
                                        <span className="font-nr">${data.price}</span>
                                    </div>
                                </Grid>

                                <Grid xs={6} sm={6} md={2} lg={2} className="sm-mt-3">
                                    <Grid xs={12} sm={12} className="sm-screen">Delivery Date:</Grid>
                                    <div className="section">
                                        <span>{data.estimatedDeliveryDate && dateMMMMDDYYYY(data.estimatedDeliveryDate)}</span>
                                    </div>
                                </Grid>

                                <DesktopOrderTrackingPlants
                                    data={{
                                        status: order.status,
                                        trackingNumber: order.trackingNumber,
                                        carrier: order.carrier,
                                        isPassport: null,
                                    }}
                                />

                                <Grid md={1} lg={1} className="sm-hide">
                                    <div className="section">
                                        <span>${data.price}</span>
                                    </div>
                                </Grid>
                            </Grid>
                        );
                    })
                ))}
            </Grid>
        </div>
    );
};

DesktopOrderListItem.propTypes = {
    classes: object.isRequired,
    orderDetails: object.isRequired,
};

export default withStyles(styles)(DesktopOrderListItem);
